import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
const Exchanges = () => {
  return (
    <div>
      <Navbar />
      <Hero />
    </div>
  );
};

export default Exchanges;
